import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Header from 'client/features/app/components/Header.jsx'
import URLS from 'constant/URLS'
import { LogoutRequest } from 'client/features/session/actions'
import UpdatePassword from 'client/features/session/containers/UpdatePassword.jsx'

class Logged extends Component {

    componentDidUpdate() {
        //if (!this.props.session.loggingIn) this.context.router.push(URLS.session.login)
    }

    logout() {
        this.props.dispatch(LogoutRequest.get.action())
    }

    render() {
        return (
            <div>
                <Header logout={ this.logout.bind(this) } user={ this.props.session.user }/>
                <div className='wrapper'>
                    <div className='container'>
                        { !this.props.session.user || this.props.session.user.validated ? this.props.children : <UpdatePassword /> }
                    </div>
                </div>
            </div>
        )
    }
}

Logged.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    session: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session } = state
    return { session }
}

export default connect(mapStateToProps)(Logged)


// WEBPACK FOOTER //
// ./src/client/features/app/containers/Logged.jsx